import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  supportsBulkSummaryToast,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRecalculateWalkingDistance = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRecalculateWalkingDistanceProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRecalculateWalkingDistance,
    entity,
  );

  const bulkRecalculateWalkingDistanceProcess = useRecoilValue(
    activeProcessSF(bulkRecalculateWalkingDistanceProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRecalculateWalkingDistance,
      process: bulkRecalculateWalkingDistanceProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: supportsBulkSummaryToast(entity),
    });
  }, [
    bulkRecalculateWalkingDistanceProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
